import { getV1CompaniesCompanyIdProjectsProjectIdAutoAddOnAssignments } from '@treadinc/horizon-api-spec';
import { useCallback } from 'react';

import { AddOnAssignment } from '~hooks/useAddOns/models';
import useMaterialRates from '~hooks/useMaterialRates/useMaterialRates';
import fetchAllPages from '~utils/fetchAllPages';

export default function useProjectQuoteData() {
  const { getCompanyMaterialRates } = useMaterialRates();

  const fetchAllMaterialRates = useCallback(
    (companyId: string, projectId: string) =>
      fetchAllPages((cursor, limit) =>
        getCompanyMaterialRates({
          companyId,
          projectIds: [projectId],
          pagination: { after: cursor, limit, page: 1 },
        }),
      ),
    [getCompanyMaterialRates],
  );

  const fetchAddOnAssignments = useCallback(
    async (companyId: string, projectId: string): Promise<AddOnAssignment[]> => {
      const resp = await getV1CompaniesCompanyIdProjectsProjectIdAutoAddOnAssignments({
        path: { 'company-id': companyId, 'project-id': projectId },
        query: { 'filter[account_type]': 'customer' },
      });
      return resp.data.data.map((a) => AddOnAssignment.parse(a));
    },
    [],
  );

  return { fetchAddOnAssignments, fetchAllMaterialRates };
}
